import { useAtomValue } from 'jotai';
import { pitchOrientationAtom } from '@/atoms/visualisation';

export const useGetPitchRotation = (isPreview: boolean) => {
  const pitchOrientation = useAtomValue(pitchOrientationAtom);
  if (isPreview) {
    return 'HORIZONTAL';
  }

  return pitchOrientation;
};
